export function getInspectionDate(
    dateFrom: string,
    dateTo: string | undefined,
    status = ""
): string {
    if (status == "UPCOMING") {
        return "TBC";
    }

    try {
        const dateFromLocale = convertDateStringToUkLocale(dateFrom);

        let dateToLocale;
        if (dateTo) {
            dateToLocale = convertDateStringToUkLocale(dateTo);
        }

        return dateToLocale
            ? `${dateFromLocale} - ${dateToLocale}`
            : dateFromLocale;
    } catch (err) {
        return "";
    }
}

export function convertDateStringToUkLocale(dateString: string): string {
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB");
    } catch (err) {
        return "";
    }
}

export const normaliseDate = (date: Date) => {
    const adjustedDate = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
    );
    return adjustedDate.toISOString().split("T")[0];
};

export const formatDecimalAge = (decimalAge: string | number) => {
    const age = Number(decimalAge);
    const years = Math.floor(age);
    const months = Math.floor(12 * (age - years));

    if (months) {
        return `${years} years ${months} months`;
    }

    return `${years} years`;
};
